import { render, staticRenderFns } from "./myWeekSelector.vue?vue&type=template&id=5aff5cc9&"
import script from "./myWeekSelector.vue?vue&type=script&lang=js&"
export * from "./myWeekSelector.vue?vue&type=script&lang=js&"
import style0 from "./myWeekSelector.vue?vue&type=style&index=0&id=5aff5cc9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports